// extracted by mini-css-extract-plugin
export default {"cleDemo":"cleDemo-BI9eM"};